// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import KwPanel from '../../common/KwPanel';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { useForm } from 'react-hook-form';
import FormSelect from '../../common/FormSelect';
import FormTextArea from '../../common/FormTextArea';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { changeStatuses, getAvailableStatuses } from '../../../api/requestApi';

export interface ChangeStatusBulkProps {
  done: (data: any) => void;
  cancel: () => void;
  requests: any[];
}

export default function ChangeStatusBulk({ done, cancel, requests }: ChangeStatusBulkProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [processing, setProcessing] = useState<boolean>(false);
  const [statuses, setStatuses] = useState<any[]>();

  useEffect(() => {
    if (!statuses) {
      getAvailableStatuses()
        .then((d) => {
          setStatuses(d.items.statuses);
        })
        .catch((e) => {
          console.error(e);
          toast.error(t('Statuses not found'));
        });
    }
  }, [statuses]);

  const onSubmit = (data: any) => {
    setProcessing(true);
    changeStatuses(requests, data.statusId, data.reason)
      .then((d) => {
        toast.success(t('Requests updated'));
        done(d);
        setProcessing(false);
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to update requests'));
        setProcessing(false);
      });
  };

  return (
    <SlideoutLayout
      title={t('Change status')}
      cancel={cancel}
      bar={
        <Button
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          isDisabled={processing}
          text={t('Change status')}
        />
      }
    >
      <KwPanel className="mb-4 form-horizontal">
        <FormSelect
          register={register}
          required
          error={errors.statusId}
          errorMessage={t('Status is required')}
          name="statusId"
          label={t('New status')}
          placeholder=""
        >
          <option value="">{t('--- choose ---')}</option>
          {statuses?.map((x) => (
            <option key={x.value} value={x.value}>
              {x.text}
            </option>
          ))}
        </FormSelect>
        <FormTextArea
          register={register}
          required
          error={errors.reason}
          errorMessage={t('Required')}
          name="reason"
          label={t('Please provide a reason...')}
          placeholder=""
        />
      </KwPanel>
    </SlideoutLayout>
  );
}
